import checkUnitAvailable from '../../../util/checkUnitAvailable'

export default function checkFirstTimeClouds(mapData) {
  const isUnitAvailable = checkUnitAvailable(mapData)

  return mapData?.opened_at === null && isUnitAvailable
}
